interface CrashScreenProps {
  text: string;
  onContinue: () => void;
}

export function CrashScreen({ text, onContinue }: CrashScreenProps) {
  return (
    <div className="act-overlay act-overlay--crash" role="alertdialog" aria-modal="true">
      <div className="act-overlay__panel act-overlay__panel--crash">
        <div className="act-crash-icon" aria-hidden>
          💥
        </div>
        <h2>CRASH!</h2>
        <p>{text}</p>
        <button type="button" className="jari-btn jari-btn--primary" onClick={onContinue}>
          Wat ging er mis?
        </button>
      </div>
    </div>
  );
}
